import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// The admin type scale (features/admin_design/admin_theme.css) adds
// custom font-size utilities. Without registration, tailwind-merge
// classifies `text-admin-sm` as a text *color* and drops a real color
// class (e.g. `text-admin-ink`) that appears alongside it.
const customTwMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [
                {
                    text: [
                        'admin-xs',
                        'admin-sm',
                        'admin-base',
                        'admin-lg',
                        'admin-xl',
                        'admin-2xl',
                    ],
                },
            ],
        },
    },
});

export function cn(...inputs: Array<ClassValue>) {
    return customTwMerge(clsx(inputs));
}
